module.exports = __webpack_public_path__ + "static/media/img_12.9404cf78.png";